import React, { useEffect } from 'react'

import ActionPreviewDivider from 'components/common/ActionPreviewDivider'

import HeaderBar from './HeaderBar'
import SideBar from './SideBar'

import Styles from './styles.module.css'

const CreateModal = ({
  open,
  steps = [],
  headerTitle,
  children,
  onSave,
  onClose,
  loading,
  currentStep,
  setCurrentStep
}) => {
  useEffect(() => {
    setCurrentStep(0)
  }, [open])

  return (
    <div
      className={`${Styles.container} ${!open && Styles['hidden-container']}`}
    >
      <HeaderBar
        steps={steps}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        headerTitle={headerTitle}
        onSave={onSave}
        onClose={onClose}
        loading={loading}
      />

      <ActionPreviewDivider
        leftContent={
          <SideBar
            title={steps[currentStep]?.title}
            description={steps[currentStep]?.description}
            content={steps[currentStep]?.content}
            actions={steps[currentStep]?.actions}
          />
        }
        rightContent={children}
      ></ActionPreviewDivider>
    </div>
  )
}

export default CreateModal
